import {Component, OnInit} from '@angular/core';
import {CommonService} from '../../services/common.service';
import {takeUntil} from 'rxjs/operators';
import {UnsubscribingComponent} from '../../modules/shared/unsubscribing.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent extends UnsubscribingComponent implements OnInit {
  public title = 'Vyhľadávanie';

  constructor(private commonService: CommonService) {
    super();
  }

  ngOnInit(): void {
    this.commonService.currentPage
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((name: string) => {
        this.title = name ? name : 'Vyhľadávanie';
      });
  }

}
